<template>
    <div class="mine-div">
        <SideBar />
        <div class="mid">
            <!-- 游戏标题与控制区 -->
            <!-- <div class="game-header"> -->
                <!-- 游戏状态信息 -->
                <div class="game-status-bar">
                    <div class="status-item">
                        <span class="status-label" style="color: #8bc34a">经典扫雷</span>
                    </div>
                    <div class="status-item">
                        <span class="status-label">剩余地雷：</span>
                        <span class="status-value mine-count">{{ remainingMines }}</span>
                    </div>
                    <div class="status-item">
                        <span class="status-label">状态：</span>
                        <span class="status-value" :class="gameStatus">{{ gameStatusText }}</span>
                    </div>
                    <button class="restart-btn" @click="resetGame">
                        <i class="restart-icon">🔄</i> 重新开始
                    </button>
                </div>
            <!-- </div> -->

            <!-- 扫雷游戏棋盘 -->
            <div class="mine-game-board" :style="{
                '--row-count': gameRows,
                '--col-count': gameCols,
                '--cell-size': isMobile ? '20px' : '32px'
            }">
                <div class="mine-cell" v-for="(cell, index) in gameCells" :key="index" :class="[
                    cell.isRevealed ? 'revealed' : '',
                    cell.isFlagged ? 'flagged' : '',
                    cell.isMine ? 'mine' : '',
                    cell.isRevealed && cell.adjacentMines > 0 ? `num-${cell.adjacentMines}` : ''
                ]" @click="handleLeftClick(index)" @contextmenu.prevent="handleRightClick(index)"
                    :disabled="gameStatus !== 'playing' || cell.isRevealed">
                    <template v-if="cell.isRevealed">
                        <span v-if="cell.isMine" class="cell-content">💣</span>
                        <span v-else-if="cell.adjacentMines > 0" class="cell-content">{{ cell.adjacentMines }}</span>
                    </template>
                    <template v-else-if="cell.isFlagged">
                        <span class="cell-content">🚩</span>
                    </template>
                </div>
            </div>
            <div v-if="isMobile" class="mobile-tip">
                注：长按格子标记地雷，轻点格子翻开
            </div>
            <div v-if="!isMobile" class="mobile-tip">
                注：鼠标右键点击标记地雷，鼠标左键点击格子翻开！
            </div>
            <!-- <div class="game-header"> -->

                <!-- 模式选择器：遍历过滤后的模式列表 -->
                <div class="mode-select-group">
                    <button v-for="mode in displayGameModes" :key="mode.key"
                        :class="['mode-btn', { active: currentMode.key === mode.key }]" @click="switchGameMode(mode)">
                        {{ mode.name }}
                    </button>
                </div>
            <!-- </div> -->
        </div>
        <BottomTip style="position: fixed; bottom: 0; z-index: 100" />
    </div>
</template>

<script>
import SideBar from '@/components/menu/SideBar.vue';
import BottomTip from '@/components/menu/BottomTip.vue';
import { Message } from 'element-ui';

export default {
    name: 'Mine',
    components: {
        SideBar,
        BottomTip,
    },
    data() {
        return {
            // 游戏模式定义
            gameModes: [
                { key: 'easy', name: '简单', rows: 9, cols: 9, mines: 10 },
                { key: 'medium', name: '中等', rows: 16, cols: 16, mines: 40 },
                { key: 'hard', name: '困难', rows: 16, cols: 30, mines: 99 }
            ],
            currentMode: null,       // 当前选中模式
            gameRows: 9,             // 游戏行数
            gameCols: 9,             // 游戏列数
            totalMines: 10,          // 总地雷数
            remainingMines: 10,      // 剩余地雷数
            gameCells: [],           // 游戏格子数据
            gameStatus: 'playing',   // 游戏状态: playing/win/lose
            firstClick: true,        // 是否首次点击
            isMobile: false,         // 是否移动端

            // 自定义模式配置
            customRows: 10,
            customCols: 10,
            customMines: 15
        };
    },
    computed: {
        // 游戏状态文本
        gameStatusText() {
            const statusMap = {
                playing: '进行中',
                win: '🎉 恭喜获胜！',
                lose: '💥 游戏失败！'
            };
            return statusMap[this.gameStatus] || '进行中';
        },
        // 自定义模式最大地雷数
        maxCustomMines() {
            return Math.max(1, (this.customRows * this.customCols) - 1);
        },
        // 【核心】过滤显示的模式：移动端隐藏困难模式
        displayGameModes() {
            if (this.isMobile) {
                // 移动端只显示简单、中等模式
                return this.gameModes.filter(mode => mode.key !== 'hard');
            } else {
                // 桌面端显示所有模式
                return [...this.gameModes];
            }
        }
    },
    watch: {
        // 监听自定义行列变化，限制地雷数
        customRows(newVal) {
            this.customMines = Math.min(this.customMines, this.maxCustomMines);
        },
        customCols(newVal) {
            this.customMines = Math.min(this.customMines, this.maxCustomMines);
        },
        // 监听设备切换，重置当前模式（防止移动端选中困难模式）
        isMobile(newVal) {
            if (newVal && this.currentMode?.key === 'hard') {
                // 移动端切换时，若当前是困难模式，自动切到中等模式
                this.currentMode = this.gameModes.find(mode => mode.key === 'medium');
                this.gameRows = this.currentMode.rows;
                this.gameCols = this.currentMode.cols;
                this.totalMines = this.currentMode.mines;
                this.resetGame();
                Message.info('移动端不包含困难模式哦~');
            }
        }
    },
    created() {
        // 初始化默认模式
        this.currentMode = this.gameModes[0];
        // 检测移动端
        this.checkMobileDevice();
    },
    mounted() {
        // 初始化游戏
        this.resetGame();
        // 监听窗口大小变化
        window.addEventListener('resize', this.checkMobileDevice);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.checkMobileDevice);
    },
    methods: {
        // 检测是否为移动端
        checkMobileDevice() {
            this.isMobile = window.innerWidth <= 768;
        },

        // 切换游戏模式
        switchGameMode(mode) {
            this.currentMode = mode;
            if (mode.key !== 'custom') {
                this.gameRows = mode.rows;
                this.gameCols = mode.cols;
                this.totalMines = mode.mines;
                this.resetGame();
                Message.success(`已切换到${mode.name}模式`);
            }
        },

        // 应用自定义模式配置
        applyCustomMode() {
            // 数据验证
            if (!this.customRows || !this.customCols || !this.customMines) {
                Message.error('请填写完整的配置信息');
                return;
            }
            if (this.customRows < 5 || this.customRows > 30) {
                Message.error('行数需在5-30之间');
                return;
            }
            if (this.customCols < 5 || this.customCols > 40) {
                Message.error('列数需在5-40之间');
                return;
            }
            if (this.customMines < 1 || this.customMines > this.maxCustomMines) {
                Message.error(`地雷数需在1-${this.maxCustomMines}之间`);
                return;
            }

            // 应用配置
            this.gameRows = this.customRows;
            this.gameCols = this.customCols;
            this.totalMines = this.customMines;
            this.resetGame();
            Message.success('自定义模式配置已生效');
        },

        // 重置游戏
        resetGame() {
            this.gameStatus = 'playing';
            this.firstClick = true;
            this.remainingMines = this.totalMines;

            // 初始化游戏格子
            this.gameCells = Array.from({ length: this.gameRows * this.gameCols }, () => ({
                isMine: false,
                isRevealed: false,
                isFlagged: false,
                adjacentMines: 0
            }));
        },

        // 生成地雷（首次点击后，避开首次点击位置）
        generateMines(avoidIndex) {
            let minesPlaced = 0;
            const totalCells = this.gameRows * this.gameCols;

            // 随机放置地雷
            while (minesPlaced < this.totalMines) {
                const randomIndex = Math.floor(Math.random() * totalCells);
                if (randomIndex !== avoidIndex && !this.gameCells[randomIndex].isMine) {
                    this.gameCells[randomIndex].isMine = true;
                    minesPlaced++;
                }
            }

            // 计算每个格子的相邻地雷数
            this.calculateAdjacentMines();
        },

        // 计算相邻地雷数
        calculateAdjacentMines() {
            this.gameCells.forEach((cell, index) => {
                if (!cell.isMine) {
                    const row = Math.floor(index / this.gameCols);
                    const col = index % this.gameCols;
                    let count = 0;

                    // 遍历8个相邻格子
                    for (let r = Math.max(0, row - 1); r <= Math.min(this.gameRows - 1, row + 1); r++) {
                        for (let c = Math.max(0, col - 1); c <= Math.min(this.gameCols - 1, col + 1); c++) {
                            if (r === row && c === col) continue;
                            const adjIndex = r * this.gameCols + c;
                            if (this.gameCells[adjIndex].isMine) count++;
                        }
                    }

                    cell.adjacentMines = count;
                }
            });
        },

        // 左键点击格子
        handleLeftClick(index) {
            const cell = this.gameCells[index];

            // 游戏结束/已标记/已翻开 不响应
            if (this.gameStatus !== 'playing' || cell.isFlagged || cell.isRevealed) return;

            // 首次点击生成地雷（避免点到地雷）
            if (this.firstClick) {
                this.generateMines(index);
                this.firstClick = false;
            }

            // 踩到地雷
            if (cell.isMine) {
                this.gameOver(false);
                return;
            }

            // 翻开格子
            this.revealCell(index);

            // 检查是否获胜
            this.checkWinCondition();
        },

        // 右键标记/取消标记
        handleRightClick(index) {
            const cell = this.gameCells[index];

            // 游戏结束/已翻开 不响应
            if (this.gameStatus !== 'playing' || cell.isRevealed) return;

            // 切换标记状态
            cell.isFlagged = !cell.isFlagged;

            // 更新剩余地雷数
            this.remainingMines = this.totalMines - this.gameCells.filter(c => c.isFlagged).length;

            // 检查是否获胜
            this.checkWinCondition();
        },

        // 翻开格子（递归处理空白区域）
        revealCell(index) {
            const cell = this.gameCells[index];

            // 跳过已标记/已翻开/地雷格子
            if (cell.isFlagged || cell.isRevealed || cell.isMine) return;

            // 标记为已翻开
            cell.isRevealed = true;

            // 空白格子（相邻地雷数为0）递归翻开周围格子
            if (cell.adjacentMines === 0) {
                const row = Math.floor(index / this.gameCols);
                const col = index % this.gameCols;

                for (let r = Math.max(0, row - 1); r <= Math.min(this.gameRows - 1, row + 1); r++) {
                    for (let c = Math.max(0, col - 1); c <= Math.min(this.gameCols - 1, col + 1); c++) {
                        if (r === row && c === col) continue;
                        const adjIndex = r * this.gameCols + c;
                        this.revealCell(adjIndex);
                    }
                }
            }
        },

        // 检查获胜条件
        checkWinCondition() {
            // 获胜条件：所有非地雷格子都已翻开 或 所有地雷都被正确标记
            const revealedNonMines = this.gameCells.filter(cell => !cell.isMine && cell.isRevealed).length;
            const totalNonMines = this.gameRows * this.gameCols - this.totalMines;
            const correctlyFlagged = this.gameCells.filter(cell => cell.isMine && cell.isFlagged).length;

            if (revealedNonMines === totalNonMines || correctlyFlagged === this.totalMines) {
                this.gameOver(true);
            }
        },

        // 游戏结束
        gameOver(isWin) {
            this.gameStatus = isWin ? 'win' : 'lose';

            // 失败时显示所有地雷
            if (!isWin) {
                this.gameCells.forEach(cell => {
                    if (cell.isMine) cell.isRevealed = true;
                });
                Message.error('很遗憾，踩到地雷了！');
            } else {
                Message.success('恭喜你，成功完成扫雷！');
            }
        }
    }
};
</script>

<style scoped>
/* 基础布局 */
.mine-div {
    /* width: 100%; */
    min-height: calc(100vh - 100px);
    margin: 0;
    padding: 100px 0 60px 0;
    color: #fff;
}

.mid {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
}

/* 游戏头部 */
.game-header {
    width: 100%;
    max-width: 800px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 10px;
    margin-bottom: 20px;
    backdrop-filter: blur(10px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.game-title {
    text-align: center;
    margin: 0 0 5px;
    color: #fff;
    font-size: 16px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* 模式选择器 */
.mode-select-group {
    display: flex;
    gap: 10px;
    margin-bottom: 5px;
    flex-wrap: wrap;
    justify-content: center;
}

.mobile-tip {
    color: #ffeb3b;
    font-size: 14px;
    text-align: center;
    margin-bottom: 10px;
    padding: 8px 16px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
}

.mode-btn {
    padding: 5px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.mode-btn.active {
    background: #4caf50;
    border-color: #4caf50;
    color: #fff;
    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

.mode-btn:hover:not(.active) {
    border-color: #8bc34a;
    background: rgba(255, 255, 255, 0.15);
}

/* 自定义模式面板 */
.custom-mode-panel {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    padding: 10px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    margin-bottom: 15px;
    align-items: center;
    justify-content: center;
}

.config-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.config-input {
    width: 60px;
    padding: 8px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    text-align: center;
    font-size: 14px;
}

.config-tip {
    font-size: 12px;
    color: #ccc;
}

.confirm-config-btn {
    padding: 8px 20px;
    background: #2196f3;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.3s;
}

.confirm-config-btn:hover {
    background: #1976d2;
}

/* 游戏状态栏 */
.game-status-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 5px;
    /* border-top: 1px solid rgba(255, 255, 255, 0.2); */
    flex-wrap: wrap;
    gap: 5px;
}

.status-item {
    height: 18px;
    display: flex;
    align-items: center;
    gap: 5px;
}

.status-label {
    font-size: 14px;
    color: #ddd;
}

.status-value {
    font-size: 16px;
    font-weight: bold;
}

.mine-count {
    color: #ff9800;
}

.playing {
    color: #8bc34a;
}

.win {
    color: #4caf50;
}

.lose {
    color: #f44336;
}

.restart-btn {
    padding: 5px;
    background: #ff5722;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    transition: background 0.3s;
}

.restart-btn:hover {
    background: #e64a19;
}

.restart-icon {
    font-size: 14px;
}

/* 游戏棋盘 */
.mine-game-board {
    display: grid;
    grid-template-rows: repeat(var(--row-count), var(--cell-size));
    grid-template-columns: repeat(var(--col-count), var(--cell-size));
    gap: 2px;
    background: rgba(0, 0, 0, 0.2);
    padding: 8px;
    border-radius: 8px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    margin-bottom: 20px;
    /* 移动端棋盘最大宽度限制 */
    max-width: 100vw;
    overflow-x: auto;
}

/* 游戏格子 */
.mine-cell {
    width: var(--cell-size);
    height: var(--cell-size);
    background: rgba(255, 255, 255, 0.3);
    border: 1px solid rgba(221, 219, 219, 0.7);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: bold;
    user-select: none;
    transition: all 0.2s ease;
}

.mine-cell:hover:not(.revealed):not(.flagged) {
    background: rgba(255, 255, 255, 0.25);
    transform: scale(1.05);
}

.mine-cell.revealed {
    background: rgba(255, 255, 255, 0.08);
    cursor: default;
}

.mine-cell.flagged {
    background: rgba(255, 193, 7, 0.3);
    color: #d5d2d2;
}

.cell-content {
    font-size: 14px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* 数字颜色 */
.mine-cell.num-1 {
    color: #64b5f6;
}

.mine-cell.num-2 {
    color: #81c784;
}

.mine-cell.num-3 {
    color: #e57373;
}

.mine-cell.num-4 {
    color: #ba68c8;
}

.mine-cell.num-5 {
    color: #ff8a65;
}

.mine-cell.num-6 {
    color: #4dd0e1;
}

.mine-cell.num-7 {
    color: #9575cd;
}

.mine-cell.num-8 {
    color: #757575;
}

/* 响应式适配 */
@media only screen and (max-width: 768px) {
    .mine-div {
        padding: 100px 0;
        min-height: calc(100vh - 80px);
    }

    .game-header {
        width: 95%;
        padding: 15px;
    }

    .game-title {
        font-size: 24px;
    }

    .mode-select-group {
        justify-content: center;
    }

    .game-status-bar {
        justify-content: center;
    }

    .mine-game-board {
        padding: 5px;
        max-width: 95vw;
    }
}

@media only screen and (max-width: 480px) {
    .game-header {
        padding: 10px;
    }

    .mode-btn {
        padding: 8px 12px;
        font-size: 14px;
    }

    .custom-mode-panel {
        gap: 10px;
        padding: 10px;
    }

    .config-input {
        width: 50px;
        padding: 6px;
    }
}
</style>